import { FEELING_ICONS, TileSection } from '@iheartjane/menu';
import capitalize from 'lodash-es/capitalize';
import differenceBy from 'lodash-es/differenceBy';

import type { InternalFeeling } from '@jane/kiosk/data-access';
import type { Store } from '@jane/shared/types';

import { ProductDetailsSection } from '../ProductDetailsSection/ProductDetailsSection';

export type FeelingSectionProps = {
  disabledFeelings: Store['disabled_feeling_and_activity_tags'];
  feelings: InternalFeeling[];
  isLoading: boolean;
};

export const FeelingSection = ({
  disabledFeelings,
  isLoading,
  feelings,
}: FeelingSectionProps) => {
  const validFeelings = differenceBy(feelings, disabledFeelings, (value) =>
    typeof value === 'string'
      ? value.toLowerCase()
      : value.feeling.toLowerCase()
  )
    .slice(0, 3)
    .map(({ feeling }) => ({
      label: capitalize(feeling),
      icon: FEELING_ICONS[capitalize(feeling)],
    }));

  return validFeelings.length > 0 ? (
    <ProductDetailsSection
      ariaLabel="product feelings section"
      isLoading={isLoading}
    >
      <TileSection label="Top customer feelings" tiles={validFeelings} />
    </ProductDetailsSection>
  ) : null;
};
